import React, { useEffect, useState } from "react";
import { FormValidate } from "../../../../../components/formValidate";
import CustomButton from "../../../../../components/inputs/button";
import Loader from "../../../../../components/loader/loader";
import Snackbar from "../../../../../components/snackbar/snackbar";
import {
  admin_areatype_add,
  admin_areatype_edit,
  admin_rentarea_add,
  admin_rentarea_edit,
} from "../../../admin.api";
import "./dialog.css";
import TextField from "../../../../../components/inputs/textfield";

const Dialog = ({ open, edit, view, handleClose, formData: initialData }) => {
  const [formData, setFormData] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const [snackMessage, setSnackMessage] = useState("");
  const [isSnackError, setIsSnackError] = useState(false);
  const [snackOpen, setSnackOpen] = useState(false);

  useEffect(() => {
    if (initialData) {
      setFormData(initialData);
    } else {
      setFormData({});
    }
  }, [initialData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };
  const handleNumberChange = (e) => {
    const { name, value } = e.target;
    const validNumber = /^\d*\.?\d*$/;
    if (validNumber.test(value)) {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };
  const snackbarClose = (flag) => {
    setSnackMessage("");
    setIsSnackError(false);
    setSnackOpen(false);
    if (!flag) handleClose();
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const error = FormValidate(formData);

    if (Object.keys(error).length === 0) {
      setIsActive(true);
      const data = {
        building_name: formData.building_name,
        floor_name: formData.floor_name,
        rentable_area_sqft: formData.rentable_area_sqft,
      };

      const submitAction = edit
        ? admin_rentarea_edit(formData.id, data)
        : admin_rentarea_add(data);

      submitAction
        .then((res) => {
          setSubmitted(true);
          setSnackMessage(res.message);
          setIsSnackError(false);
          setSnackOpen(true);
        })
        .catch((err) => {
          setSubmitted(false);
          setSnackMessage(err.message);
          setIsSnackError(true);
          setSnackOpen(true);
        })
        .finally(() => setIsActive(false));
    } else {
      setSubmitted(false);
      setSnackMessage("Please fill all mandatory fields");
      setIsSnackError(true);
      setSnackOpen(true);
    }
  };

  if (!open) return null;

  return (
    <div className="overlay">
      <Loader open={isActive} />
      <div className="big-dia dialog">
        <Snackbar
          message={snackMessage}
          error={isSnackError}
          open={snackOpen}
          close={snackbarClose}
        />
        <div className="row">
          <div className="flexDisplay">
            <div className="diaTitleCon">
              {edit ? "Edit Rent Area" : view ? "Rent Area" : "Add Rent Area"}
            </div>
            <div className="dia-close" onClick={handleClose}>
              <div className="diaCloseCon">
                <div className="diaClose">&#10005;</div>
              </div>
            </div>
          </div>
          <div className="tilebar d-flex justify-content-start">
            <hr />
          </div>
          <form onSubmit={handleSubmit}>
            <div className="book-form">
              <div className="col-12">
                <TextField
                  label="Building Name"
                  name="building_name"
                  variant="outlined"
                  disabled={view}
                  type="text"
                  value={formData?.building_name ?? ""}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="col-12">
                <TextField
                  label="Floor Name"
                  name="floor_name"
                  variant="outlined"
                  disabled={view}
                  type="text"
                  value={formData?.floor_name ?? ""}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="col-12">
                <TextField
                  label="Rentable Area in sq.ft"
                  name="rentable_area_sqft"
                  variant="outlined"
                  disabled={view}
                  type="text"
                  value={formData?.rentable_area_sqft ?? ""}
                  onChange={handleNumberChange}
                  required
                />
              </div>

              {!view && (
                <div className="col-12">
                  <CustomButton
                    label={edit ? "Update" : "Add"}
                    disabled={submitted}
                    onClick={handleSubmit}
                  />
                </div>
              )}
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Dialog;
